import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description PulseCheck icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { PulseCheck } from '@sravni/design-system-icons'
 *
 * <PulseCheck />
 * ```
 */
var PulseCheck = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "PulseCheck", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.143 10h-2.857l-2.143 6.428L7.857 3.571 5.715 10H2.857", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { PulseCheck };
//# sourceMappingURL=PulseCheck.js.map
